import axios from "axios";
import store from "@/store";

// Request interceptor
axios.interceptors.request.use(request => {
  const token = store.getters["auth/token"];
  if (token) {
    request.headers.common["Authorization"] = `Bearer ${token}`;
  }

  // request.headers['X-Socket-Id'] = Echo.socketId()

  return request;
});



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/axios.js